export const getPreviousCategory = () => {
  let previousCategory = null;

  if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') {
    const storedCategory = window.localStorage.getItem('previousCategory');
    previousCategory = storedCategory ? JSON.parse(storedCategory).categoryName : null;

    // deleted once captured to ensure that only direct-from-category traffic is tracked
    window.localStorage.removeItem('previousCategory');
  }

  return previousCategory;
};
